(function () {
  var $search = $('#categoriesSearch');
  var $grid = $('#categoriesGrid');
  var $items = $grid.find('.category-item');
  var $count = $('#categoriesCount');
  var $noResults = $('#categoriesNoResults');

  function updateFilter() {
    var q = ($search.val() || '').trim().toLowerCase();
    var visible = 0;

    $items.each(function () {
      var $el = $(this);
      var name = $el.data('name') || '';
      var desc = $el.data('desc') || '';
      var show = !q || name.indexOf(q) !== -1 || desc.indexOf(q) !== -1;
      $el.toggleClass('d-none', !show);
      if (show) visible++;
    });

    $count.text(visible + ' categor' + (visible === 1 ? 'y' : 'ies'));
    $noResults.toggleClass('d-none', visible > 0);
  }

  $search.on('input', updateFilter);
})();
